import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface PanelProps extends HTMLAttributes<HTMLElement> {
  as?: 'section' | 'article' | 'div' | 'aside';
  children: ReactNode;
}

/** The surface every card in the app sits on. */
export function Panel({ as: Tag = 'section', className, children, ...props }: PanelProps) {
  return (
    <Tag
      className={cn(
        'rounded-panel border border-border bg-white/[0.02] p-5 shadow-[0_8px_24px_rgba(0,0,0,0.2)]',
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}
